import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import ProductVariantColorSelect from '../../components/product-variant-color-select';
import FloatingMessage from '../../components/floating-message';
import VideoModalButton from '../../components/video-modal-button';
$(() => {
    RevealWhenVisible.init();
    ProductVariantColorSelect.init();
    FloatingMessage.init();
    VideoModalButton.init();
});
